// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RStx","largestCol":"styles_largestCol__1Aq1W","smallestCol":"styles_smallestCol__KHp_9"};